// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Mywallet.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link, useHistory } from "react-router-dom";
// import axios from "axios";
// import socket from "../Components/socket";
// import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
// import { BsWallet2 } from "react-icons/bs";
// import io from "../Components/socket";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { VscReferences } from "react-icons/vsc";

// const Mywallet = ({ user }) => {
//   // const [user, setUser] = useState();

//   const access_token = localStorage.getItem("token");
//   //   const walletUpdate =()=>{
//   //  io.emit("getprofile", access_token);
//   //   io.on("setProfile", (data) => {
//   //     setUser(data);
//   //   });
//   //   }

//   //   useEffect(()=>{
//   //     walletUpdate()
//   //   },[]);

//   // language
//   const translations = {
//     hi: {
//       wallet: "वॉलेट",
//       history: "इतिहास देखे | ",
//       amount: "पैसे जोड़ें | ",
//       withdraw: "पैसे निकाले  | ",
//       referPerson: "रेफ़रल | ",
//     },
//     en: {
//       wallet: "My Wallet",
//       history: "Order History",
//       amount: "Add Cash",
//       withdraw: "Withdraw",
//       referPerson: "Referral",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme = localStorage.getItem("theme");

//   const styles = {
//     backgroundColor: theme === "light" ? "#d3e3fd" : "#000",
//     color: theme === "light" ? "black" : "#fff",
//   };

//   return (
//     <>
//       <div
//         className="leftContainer mb_space"
//         style={{ ...styles, height: "100vh" }}
//       >
//         <div className="balance-section pt-2 mt-5 Orher_page_main_section">
//           <div className="mt-2">
//             <h3 className="mb-3">Balance</h3>

//             {/* Deposit Cash Card */}
//             <div className="unique-card">
//               <div className="unique-card-left">
//                 <img src="/images/deposit.png" className="card-main-img" />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Deposit Cash</h2>

//                 <div className="uc-amount">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.Wallet_balance - user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/addcase">
//                   <button className="uc-btn">
//                     <AiOutlinePlus className="icons" />{" "}
//                     {translations[language].amount}
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Winning Cash Card */}
//             <div className="unique-card win">
//               <div className="unique-card-left">
//                 <img
//                   src="/images/win-cash.png"
//                   className="card-main-img"
//                   style={{ transform: "scale(1.5)" }}
//                 />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Winning Cash</h2>

//                 <div className="uc-amount text-danger">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/Withdrawopt">
//                   <button className="uc-btn withdraw">
//                     <BsWallet2 className="icons" />{" "}
//                     {translations[language].withdraw}
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="rightContainer">
//           <div>
//             <Rightcontainer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Mywallet;


import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "डिपॉजिट चिप्स",
      winnings: "विनिंग चिप्स",
      availablePlay: "खेलने के लिए उपलब्ध",
      withdrawBal: "निकालने योग्य शेष",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
    },
    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      availablePlay: "Available for play",
      withdrawBal: "Withdrawable balance",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
  const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

  return (
    <>
      {/* Dynamic CSS Injected Directly into the Component for Seamless Integration */}
      <style>{`
        .wallet-page-wrapper {
          display: flex;
          justify-content: center;
          gap: 30px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          font-family: 'Poppins', system-ui, -apple-system, sans-serif;
          color: #ffffff;
        }

        .wallet-main-content {
          flex: 1;
          max-width: 600px;
          
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          padding: 30px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        /* --- Verification Header Banner --- */
        .status-banner {
          display: flex;
          align-items: center;
          gap: 20px;
          background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.03));
          border: 1px solid rgba(16, 185, 129, 0.2);
          border-radius: 18px;
          padding: 16px 24px;
          margin-bottom: 30px;
          position: relative;
          overflow: hidden;
        }

        /* Ambient Glow Animation behind status */
        .status-banner::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(16, 185, 129, 0.15) 0%, transparent 60%);
          animation: pulseGlow 4s infinite alternate ease-in-out;
          pointer-events: none;
        }

        .avatar-wrapper {
          position: relative;
          width: 60px;
          height: 60px;
        }

        .status-avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #10b981;
          background: #1a1a24;
        }

        .plus-badge {
          position: absolute;
          bottom: -2px;
          right: -2px;
          background: #10b981;
          color: #fff;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #121218;
          box-shadow: 0 2px 5px rgba(0,0,0,0.3);
        }

        .status-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
          z-index: 1;
        }

        .status-label {
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #9ca3af;
        }

        .status-text {
          font-size: 18px;
          font-weight: 600;
          color: #10b981;
          margin: 0;
          text-shadow: 0 0 10px rgba(16, 185, 129, 0.3);
        }

        /* --- Neo-Gaming Balance Cards --- */
        .balance-card {
          border-radius: 20px;
          padding: 24px;
          margin-bottom: 24px;
          position: relative;
          overflow: hidden;
          transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .balance-card:hover {
          transform: translateY(-4px);
        }

        .deposit-card {
          background: linear-gradient(135deg, #1e1b4b 0%, #111827 100%);
          border: 1px solid rgba(99, 102, 241, 0.25);
          box-shadow: 0 10px 25px rgba(99, 102, 241, 0.1);
        }
        
        .deposit-card:hover {
          box-shadow: 0 15px 30px rgba(99, 102, 241, 0.25);
        }

        .winning-card {
          background: linear-gradient(135deg, #2e1065 0%, #111827 100%);
          border: 1px solid rgba(168, 85, 247, 0.25);
          box-shadow: 0 10px 25px rgba(168, 85, 247, 0.1);
        }

        .winning-card:hover {
          box-shadow: 0 15px 30px rgba(168, 85, 247, 0.25);
        }

        .card-top-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .card-title {
          font-size: 15px;
          font-weight: 500;
          color: #d1d5db;
        }

        .chip-icon {
          width: 32px;
          height: 32px;
          background: linear-gradient(135deg, #6366f1, #4338ca);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
          color: #fff;
          box-shadow: 0 0 12px rgba(99, 102, 241, 0.5);
        }

        .chip-icon.purple {
          background: linear-gradient(135deg, #a855f7, #7e22ce);
          box-shadow: 0 0 12px rgba(168, 85, 247, 0.5);
        }

        .amount-display {
          font-size: 36px;
          font-weight: 700;
          letter-spacing: -0.5px;
          margin-bottom: 4px;
        }

        .deposit-card .amount-display { color: #f3f4f6; }
        .winning-card .amount-display { color: #f3f4f6; }

        .amount-subtext {
          font-size: 13px;
          color: #9ca3af;
          margin-bottom: 20px;
        }

        /* --- Animated Modern Action Buttons --- */
        .action-btn {
          display: block;
          text-align: center;
          text-decoration: none;
          padding: 14px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 15px;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        /* Glossy sliding light effect on hover */
        .action-btn::after {
          content: '';
          position: absolute;
          top: 0; left: -150%; width: 50%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent);
          transform: skewX(-20deg);
          transition: 0.75s;
        }

        .action-btn:hover::after {
          left: 150%;
        }

        .add-btn {
          background: linear-gradient(90deg, #6366f1, #4f46e5);
          color: #ffffff;
          box-shadow: 0 4px 15px rgba(99, 102, 241, 0.3);
        }

        .add-btn:hover {
          background: linear-gradient(90deg, #4f46e5, #4338ca);
          box-shadow: 0 6px 20px rgba(99, 102, 241, 0.5);
        }

        .withdraw-btn {
          background: linear-gradient(90deg, #a855f7, #9333ea);
          color: #ffffff;
          box-shadow: 0 4px 15px rgba(168, 85, 247, 0.3);
        }

        .withdraw-btn:hover {
          background: linear-gradient(90deg, #9333ea, #7e22ce);
          box-shadow: 0 6px 20px rgba(168, 85, 247, 0.5);
        }

        /* --- Safe Footer --- */
        .secure-text-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 12px;
          color: #6b7280;
          text-align: center;
          margin-top: 25px;
        }

        /* Decorative padlock circle icon mock using CSS */
        .secure-text-footer::before {
          content: '🛡️';
          font-size: 14px;
        }

        /* Right Container Layout Settings */
        .rightContainer {
          width: 340px;
        }

        /* --- Keyframe Animations --- */
        @keyframes pulseGlow {
          0% { transform: scale(0.95); opacity: 0.1; }
          100% { transform: scale(1.05); opacity: 0.25; }
        }

        /* Responsive Media Query adjustment mirroring your standard style rules */
        @media (max-width: 768px) {
          .wallet-page-wrapper {
            flex-direction: column;
            align-items: center;
            padding: 15px;
          }
          .wallet-main-content {
            width: 100%;
          }
          .mobile-hide {
            display: none;
          }
        }
      `}</style>

      <div className="wallet-page-wrapper leftContainer mt-5 pt-5">
        <div className="wallet-main-content">
          
          {/* Verification Status Header */}
          <div className="status-banner">
            <div className="avatar-wrapper">
               <img src="/avatarwallet.png" alt="user" className="status-avatar" />
               <div className="plus-badge">+</div>
            </div>
            <div className="status-info">
              <span className="status-label">{t.status}</span>
              <h2 className="status-text">{t.verified}</h2>
            </div>
          </div>

          {/* Deposit Card */}
          <div className="balance-card deposit-card">
            <div className="card-top-row">
              <span className="card-title">{t.deposit}</span>
              <div className="chip-icon">₹</div>
            </div>
            <div className="amount-display">₹{depositAmount}</div>
            <div className="amount-subtext">{t.availablePlay}</div>
            <Link to="/addcase" className="action-btn add-btn">
              {t.add}
            </Link>
          </div>

          {/* Winnings Card */}
          <div className="balance-card winning-card">
            <div className="card-top-row">
              <span className="card-title">{t.winnings}</span>
              <div className="chip-icon purple">₹</div>
            </div>
            <div className="amount-display">₹{winningAmount}</div>
            <div className="amount-subtext">{t.withdrawBal}</div>
            <Link to="/Withdrawopt" className="action-btn withdraw-btn">
              {t.withdraw}
            </Link>
          </div>

          <p className="secure-text-footer">{t.secure}</p>
        </div>

        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>
      </div>
    </>
  );
};

export default Mywallet;